import { api } from "api";

export const getGroups = async (params) => {
    const response = await api.get("api/general-option-groups");
    return response.data;
};

export const getGroup = async (id) => {
    const response = await api.get("api/general-option-groups/" + id);
    return response.data;
};

export const createGroup = async (data) => {
    const response = await api.post("api/general-option-groups", data);
    return response.data;
};

export const editGroup = async (id, data) => {
    const response = await api.patch("api/general-option-groups/" + id, data);
    return response.data;
};

export const copyGroup = async (data) => {
    const response = await api.post("api/general-option-groups/copy", data);
    return response.data;
};

export const updateGroup = async (data) => {
    const response = await api.patch(`${"api/general-option-groups/" + data.get("id")}}`, data);

    return response.data;
};

export const removeGroup = async (id) => {
    const response = await api.delete(`api/general-option-groups/${id}`);
    return response.data;
};
